import _ from "lodash";
import { htmlToText as _htmlToText } from "html-to-text";

/**
 * Inserts `text` at the cursor position in an input/textarea element
 * and dispatch element's onchange handler with the updated value
 *
 * @param {HTMLInputElement} inputElement
 * @param {String} text
 */
export const insertAtCursorPosition = (inputElement, text) => {
  const { selectionStart, selectionEnd } = inputElement;
  const ev = new Event("input", {
    bubbles: true,
  });
  inputElement.focus();
  inputElement.setRangeText(text, selectionStart, selectionEnd, "end");
  inputElement.dispatchEvent(ev);
};

/**
 * Inserts stringified html and replaces spaces, &nbsp;, <div> and </div> with
 * empty string and checks whether its empty.
 * Userful for richtext editor.
 *
 * @param {String} htmlString
 */
export const isEmptyHtml = htmlString => {
  if (_.isEmpty(htmlString)) return true;
  return _.isEmpty(
    _.trim(
      htmlString
        .replace(/\s+(?=[^<>]*<)/g, "")
        .replace(/&nbsp;/gi, "")
        .replace(/<div>/gi, "")
        .replace(/<\/div>/gi, "")
    )
  );
};

/**
 * @param {String} string
 * @param {Object} options
 * @returns {String}
 *
 * @description see https://github.com/html-to-text/node-html-to-text for more info
 */
export const htmlToText = (string, options) => {
  if (_.isNil(options)) {
    options = {
      wordwrap: 130,
      uppercaseHeadings: false,
      tags: {
        a: { options: { ignoreHref: true } },
        ul: { options: { itemPrefix: " " } },
        img: { format: "skip" },
      },
    };
  }
  return _htmlToText(string, options);
};

export const convertHtmlToTextWithSpanConversion = ({
  title,
  showEmptyString = true,
}) => {
  const tempElement = document.createElement("div");
  tempElement.innerHTML = title;
  const elements = tempElement.getElementsByTagName("div");
  for (let i = 0; i < elements.length; i++) {
    const element = elements[i];
    if (!element.innerHTML && showEmptyString) {
      element.innerHTML = `""`;
    }
    element.style.cssText += "display:inline";
  }
  return tempElement.innerHTML;
};

/** @returns - a boolean whether htmlString contains iframe */
export const checkForIframeEmbedInHtmlString = htmlString => {
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    if (!doc) return false;
    const iframeElements = doc.getElementsByTagName("iframe");
    return !_.isEmpty(iframeElements);
  } catch (error) {
    return false;
  }
};
